import { render } from "./SpacerComponent.vue?vue&type=template&id=8d92838a&scoped=true"
import script from "./SpacerComponent.vue?vue&type=script&lang=js"
export * from "./SpacerComponent.vue?vue&type=script&lang=js"

import "./SpacerComponent.vue?vue&type=style&index=0&id=8d92838a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d92838a"]])

export default __exports__